'use client'

import { type ReactNode, useState } from 'react'
import { Button } from './Button'

interface Props {
  children: ReactNode
  defaultExpanded?: boolean
}

export function ExtendedSignInButtons({
  children,
  defaultExpanded = false,
}: Props) {
  const [expanded, setExpanded] = useState(defaultExpanded)

  if (expanded) {
    return (
      <>
        <span className="text-text-secondary mt-2">
          Weitere Login-Optionen:
        </span>
        {children}
        <Button
          variant="text"
          type="button"
          onClick={() => setExpanded(false)}
          className="mx-auto"
        >
          Weniger Optionen anzeigen
        </Button>
      </>
    )
  }
  return (
    <Button
      variant="text"
      type="button"
      onClick={() => setExpanded(true)}
      className="mx-auto"
    >
      Weitere Optionen anzeigen
    </Button>
  )
}
